import accountManagement from "sagas/accountManagement";
import accountSagas from "sagas/account";
import accountsSagas from "sagas/accounts";
import analyticsSagas from "sagas/analytics";
import billing from "sagas/billing";
import checklistSagas from "sagas/checklists";
import chromeExtension from "sagas/chromeExtension";
import dashboardSagas from "sagas/dashboard";
import estimationSagas from "sagas/estimation";
import eventSagas from "sagas/events";
import features from "sagas/features";
import firebaseAuthSagas from "sagas/firebase/auth";
import firebaseIoSagas from "sagas/firebase/io";
import firebaseSyncAccountSagas from "sagas/firebase/syncAccount";
import goalSagas from "sagas/goals";
import identifier from "sagas/identifier";
import lastSeen from "sagas/transitory/lastSeen";
import metricsSagas from "sagas/metrics";
import profileAttributesSagas from "sagas/profileAttributes";
import routingSagas from "sagas/routing";
import satisfactionSagas from "sagas/satisfaction";
import segmentsSagas from "sagas/segments";
import spoofing from "sagas/spoofing";
import timingSaga from "sagas/timing";
import toasterSagas from "sagas/toaster";
import userEventsSagas from "sagas/userEvents";
import userProfileSagas from "sagas/userProfiles";
import userSagas from "sagas/user";
import view from "sagas/view";

export const SAGAS = [
  ...accountSagas,
  ...firebaseIoSagas,
  accountsSagas,
  accountManagement,
  analyticsSagas,
  billing,
  checklistSagas,
  chromeExtension,
  dashboardSagas,
  estimationSagas,
  eventSagas,
  features,
  firebaseAuthSagas,
  firebaseSyncAccountSagas,
  goalSagas,
  identifier,
  lastSeen,
  metricsSagas,
  profileAttributesSagas,
  routingSagas,
  satisfactionSagas,
  segmentsSagas,
  spoofing,
  timingSaga,
  toasterSagas,
  userEventsSagas,
  userProfileSagas,
  userSagas,
  view
];
